var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExploreArrowGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4056",
    "data-name": "Rectangle 4056",
    width: 28.932,
    height: 20.995,
    fill: "#003300"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10664",
    "data-name": "Group 10664",
    transform: "translate(-619 -1436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9577",
    "data-name": "Group 9577",
    transform: "translate(619 1436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_241",
    "data-name": "Ellipse 241",
    transform: "translate(0)",
    fill: "#ffffff",
    stroke: "#003300",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9820",
    "data-name": "Group 9820",
    transform: "translate(633.847 1471.307) rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9705",
    "data-name": "Group 9705",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33409",
    "data-name": "Path 33409",
    d: "M24.334,11.788h-.366q-11.2,0-22.4,0a2.426,2.426,0,0,1-.61-.051,1.3,1.3,0,0,1,.293-2.557c.123-.006.246,0,.37,0H24.347l.11-.144a1.092,1.092,0,0,1-.3-.151q-3.3-3.278-6.583-6.566A1.313,1.313,0,0,1,19.248.291a3.141,3.141,0,0,1,.246.232L28.383,9.4a1.341,1.341,0,0,1,.006,2.16q-4.477,4.47-8.953,8.941a1.355,1.355,0,0,1-1.387.446A1.3,1.3,0,0,1,17.4,18.83c.073-.085.156-.163.236-.243q3.256-3.251,6.515-6.5a1.778,1.778,0,0,1,.275-.188l-.089-.112",
    transform: "translate(0 0)",
    fill: "#003300"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreArrowGreen);
export default __webpack_public_path__ + "static/media/explore-arrow-green.6b4c329bc63f9fcaa8647a83b0fd96f0.svg";
export { ForwardRef as ReactComponent };